export default __webpack_public_path__ + "static/c01-d6332cdd67359a2d24defaa24fdf64fd.png";